<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="isotr112283" :items="this.listIsotr112283" label="Historial" item-text="fecha"
                              return-object required></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-if="this.isotr112283!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.isotr112283.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación: {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad: {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa: {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo: {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Movimientos repetitivos ISO/TR 11228-3</div>
                    </template>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>Movimientos repetitivos ISO/TR 11228-3</h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Preguntas clave
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Identificación del peligro
                                        <br/>Pregunta Clave
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>IDENTIFICACIÓN DEL PELIGRO ERGONÓMICO POR MOVIMIENTOS REPETITIVOS DE LA EXTREMIDAD
                                    SUPERIOR</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>Marque con una “X” la respuesta a cada una de las siguientes condiciones</b>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" bgcolor="#CCCCAA">
                                <b>En el puesto de trabajo hay alguna tarea que presente alguna de las siguientes
                                    condiciones:</b>
                            </td>
                            <td align="center" bgcolor="#CCCCAA">Respuesta</td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >1) ¿La tarea está definida por ciclos independientemente del tiempo de duración de cada
                                ciclo, o se repiten los mismos gestos o movimientos con los brazos (hombro codo, muñeca
                                o mano) por más de la mitad del tiempo de la tarea?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch1"
                                          :label="`${this.isotr112283.switch1 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td
                                    bgcolor="#FFFFFF"
                            >2) ¿La tarea que se repite dura al menos 1 hora de la jornada de trabajo?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch2"
                                          :label="`${this.isotr112283.switch2 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CF6D6D">
                                <b>Si todas las respuestas son “SI”, para todas las condiciones, hay presencia del
                                    peligro por movimientos repetitivos de la extremidad y se debe realizarse una
                                    evaluación específica del riesgo.</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#ABCF6D">
                                <b>Si alguna de las respuestas a las condiciones es “NO”, no hay presencia del peligro
                                    por movimientos repetitivos de la extremidad superior.</b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <!--Fin preguntas clave-->
                    <table style="border: 3px black solid;" width="100%">
                        <tbody>
                        <tr>
                            <td colspan="2" align="center" bgcolor="#CCCCAA">
                                <b>
                                    <h1>
                                        Evaluación Rápida
                                        <br/>|
                                        <br/>˅
                                    </h1>
                                </b>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table border="1" style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                <b>
                                    <center>Evaluación rápida para identificar la presencia de condiciones aceptables
                                        (ZONA VERDE)
                                    </center>
                                    <br/>NOTA: Señale con una “X”, cuando la condición verificada está en presente
                                    (columna "SI") y cuando no está presente (columna "NO")
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>¿Las estremidades superiores están activas por más del 40% del tiempo total del trabajo
                                repetitivo (se considera como tiempo de inactividad de la extremidad superior cuando el
                                trabajador camina con las manos vacías, o lee, o hace control visual, o espera que la
                                máquina concluya el trabajo, etc.?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch3"
                                          :label="`${this.isotr112283.switch3 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿Una o ambos brazos trabajan con el codo casi a la altura del hombro por más del 10% del
                                tiempo de trabajo repetitivo?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch4"
                                          :label="`${this.isotr112283.switch4 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿La fuerza necesaria para realizar el trabajo es moderada (más que ligera) superando el
                                25% del tiempo de trabajo repetitivo?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch5"
                                          :label="`${this.isotr112283.switch5 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿Están presentes lo picos de fuerza (más que Moderada en la Escala de Borg)?</td>
                            <td>
                                <v-switch v-model="isotr112283.switch6"
                                          :label="`${this.isotr112283.switch6 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>e</td>
                            <td>¿En un turno de 6 horas o más hay una única pausa para comer y menos de 2 pausas de 10
                                minutos o más cada una (o en un tiempo'parcial de 4 ó 5 horas no hay ninguna pausa?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch7"
                                          :label="`${this.isotr112283.switch7 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si a
                                <b>todas</b> las preguntas ha contestado
                                <b>"NO"</b> entonces la tarea tiene un riesgo aceptable o está en la
                                <b>ZONA VERDE</b>.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#608E12">
                                Si
                                <b>una</b> o más respuestas son
                                <b>"SI"</b>, compruebe si se trata de una tarea con un nivel de riesgo inaceptable según
                                la siguiente tabla.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                    <table border="1" style="border: 3px black solid;">
                        <tbody>
                        <tr>
                            <td colspan="3" align="center" bgcolor="#464AD7">
                                <b>
                                    <font color="white">
                                        Estimación de riesgo
                                        <br/>"Evaluacion Rápida"
                                    </font>
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#FF0000">
                                <center>
                                    <b>Evaluación rápida para identificar la presencia de riesgo inaceptable (ZONA
                                        ROJA)</b>
                                </center>
                                <b>
                                    <br/>NOTA: Señale con una “X”, cuando la condición verificada está en presente
                                    (columna "SI") y cuando no está presente (columna "NO")
                                </b>
                            </td>
                        </tr>
                        <tr>
                            <td>a</td>
                            <td>¿La acciones técnicas de una extremidad son tan rápidas que no es posible contarlas?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch8"
                                          :label="`${this.isotr112283.switch8 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>¿Un brazo o ambos trabajan con el codo casi a la altura de hombro por casi la mitad o
                                más del tiempo?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch9"
                                          :label="`${this.isotr112283.switch9 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>¿Se realizan picos de fuerza (Fuerza "Intensa o más) durante el 5% o mas del tiempo?
                            </td>
                            <td>
                                <v-switch v-model="isotr112283.switch10"
                                          :label="`${this.isotr112283.switch10 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>En su turno de más de 6 horas ¿Sólo tiene la pausa de la comida?</td>
                            <td>
                                <v-switch v-model="isotr112283.switch11"
                                          :label="`${this.isotr112283.switch11 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>¿En el tiempo de trabajo repetitivo es superior de 8 horas en el turno?</td>
                            <td>
                                <v-switch v-model="isotr112283.switch12"
                                          :label="`${this.isotr112283.switch12 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#FF0000">
                                Si
                                <b>alguna</b> de las respuestas es
                                <b>"SI"</b> la tarea probablemente está en la
                                <b>ZONA ROJA</b> y tiene riesgo. Se recomienda realizar la evaluación especifica del
                                riesgo de la tarea repetitiva para definir intervención.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" bgcolor="#FF0000">
                                Si
                                <b>todas</b> las respuestas son
                                <b>"NO"</b>, no es posible discriminar el nivel de riesgo de forma rápida y por tanto,
                                es necesario realizar la evaluación específica.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="isotr112283!=null">
            <v-btn color="primary" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import Isotr112283 from "../../../model/Isotr11228-3"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        data() {
            return {
                isotr112283: null,
                listIsotr112283: [],
                valid: true,
                search: '',
                dialogError: false,
                dialogSuccess: false,
            }
        },
        methods: {

            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                console.log(this.isotr112283)
                this.isotr112283 = new Isotr112283();
                console.log(this.isotr112283)
                this.isotr112283.fecha = e
                this.listIsotr112283.push(this.isotr112283)
            },
            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.isotr112283.id != '' && this.isotr112283.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.isotr112283.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.isotr112283)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.isotr112283)
                        monitoringNew.form = 53
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.isotr112283.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 53
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.isotr112283 = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listIsotr112283 = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listIsotr112283.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

        },
        computed: {}
    }
</script>

<style scoped>
    v-switch {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/Isotr11228-3.vue